<div class="flex flex-col items-center justify-center p-4 text-center" cdkTrapFocus cdkTrapFocusAutoCapture="true">
  <div class="flex flex-col gap-2">
    @if (state.hasUnlimitedCredits) {
      <dojo-image
        class="mx-auto"
        [src]="'assets/images/sidebar/coin-unlimited.svg'"
        [alt]="'examdojo.billing.unlimited_credits' | transloco"
        [classes]="'w-[64px] h-[64px]'"
      ></dojo-image>
    } @else {
      <div class="aligner p-1.5">
        <dojo-image
          [src]="'assets/images/sidebar/belt-coin.svg'"
          [alt]="'examdojo.billing.marks_grading_coin' | transloco"
          [classes]="'w-[54px] h-[54px]'"
        ></dojo-image>
      </div>
    }
    <div class="text-primary text-display-xs font-semibold">
      @if (state.hasUnlimitedCredits) {
        {{ 'examdojo.billing.unlimited_credits' | transloco }}
      } @else {
        {{
          'examdojo.billing.marks_grading_coin'
            | transloco: { count: state.remainingMarks, formattedCount: state.remainingMarks }
        }}
      }
    </div>
    <div class="text-secondary text-md font-normal">
      @if (state.hasUnlimitedCredits) {
        {{ 'examdojo.billing.pro_unlocked' | transloco }}
      } @else {
        {{ 'examdojo.billing.marks_grading_explanation' | transloco }}
      }
    </div>
  </div>

  @if (!state.hasUnlimitedCredits) {
    @if (state.nextRefresh && state.nextRefreshAmount) {
      <div class="text-secondary text-md mt-4 flex flex-wrap justify-center gap-1 font-semibold">
        <span>{{
          'examdojo.billing.next_refill_amount'
            | transloco: { count: state.nextRefreshAmount, formattedCount: state.nextRefreshAmount }
        }}</span>
        <dojo-time-ago
          class="inline text-red-500"
          [relativeConfig]="{
            showIfDaysDiff: 14
          }"
          [date]="state.nextRefresh"
        ></dojo-time-ago>
      </div>
    }
    @if (state.remainingMarks < 100) {
      <dojo-button
        [autoFocus]="true"
        class="special-button mt-4 w-full overflow-hidden"
        (click)="redirectToBilling()"
        [customColor]="'amber'"
      >
        <span class="z-1">{{ 'examdojo.billing.upgrade_to_pro' | transloco }}</span>
        <span class="stripes"></span>
      </dojo-button>
    }
  }
</div>
